<nz-card [nzTitle]="titleTmpl" class="mt-2">
	<ng-template #titleTmpl>
		Operations
	</ng-template>

	<div class="row" *ngIf="readonly == false && !ticket.id">
		<div class="col">
			<nz-form-item [formGroup]="masterForm">
				<nz-form-label [nzSpan]="10" [nzRequired]="!ticket.id">
					Assign Claim
				</nz-form-label>
				<nz-form-control [nzSpan]="10">
					<nz-select formControlName="assignToAgent" nzPlaceHolder="Select an option" nzAllowClear nzShowSearch>
						<nz-option *ngFor="let agent of availableAgents" [nzValue]="agent.id" nzLabel="{{agent.firstName}} {{agent.lastName}}"></nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<div class="notes-header">
				<span>Notes:</span>
			</div>

			<div *ngIf="readonly == false" class="add-note-form">
				<div [formGroup]="masterForm">
					<nz-form-item>
						<nz-form-label [nzSpan]="10"  [nzRequired]="false" nzFor="operationalNote">
							Operational Note
						</nz-form-label>
						<nz-form-control [nzSpan]="10">
							<textarea nz-input formControlName="operationalNote" placeholder="Note"></textarea>
						</nz-form-control>
					</nz-form-item>
				</div>
			</div>
		</div>
	</div>
</nz-card>
